import React from 'react';
import { Badge, Tooltip } from '@chakra-ui/react';

import { IFechamentoModuloInfo } from '../../../../../hooks/useFechamentos';
import { STATUS_COLORS, buildBadgeText, buildBadgeTooltip } from '../helpers';

interface FechamentoBadgeProps {
  info: IFechamentoModuloInfo;
  size?: 'sm' | 'md';
}

/**
 * Badge que exibe o status do fechamento de 1 modulo (folha/fiscal/contabil/patrimonio)
 * com cor + texto + tooltip detalhado.
 */
export const FechamentoBadge = ({ info, size = 'sm' }: FechamentoBadgeProps) => {
  return (
    <Tooltip label={buildBadgeTooltip(info)} placement="top" hasArrow>
      <Badge
        colorScheme={STATUS_COLORS[info.status]}
        variant="subtle"
        fontSize={size === 'sm' ? '11px' : '13px'}
        px={2}
        py={1}
        borderRadius="md"
        textTransform="none"
        fontWeight="medium"
      >
        {buildBadgeText(info)}
      </Badge>
    </Tooltip>
  );
};
